// extracted by mini-css-extract-plugin
module.exports = {"card":"TopCard_card__1BWpZ","btn":"TopCard_btn__GsbZf","extra":"TopCard_extra__1V83k"};